module.exports = {"451227100":"巴马镇","451227101":"甲篆镇","451227102":"燕洞镇","451227202":"那社乡","451227203":"所略乡","451227205":"西山乡","451227207":"东山乡","451227208":"凤凰乡","451227209":"百林乡","451227210":"那桃乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451227.json
// module id = 1990
// module chunks = 0